import { Link } from 'react-router-dom';
import { Theme, useMediaQuery } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';
import { classifications } from '@common-types';

import { ROUTES } from '@constants/ROUTES';
import { useStudyAreas } from '@hooks/useStudyAreas';
import { AreaOfStudyCard } from '@components/AreaOfStudyCard';
import ActionButton from '@components/ActionButton';
import { Container } from '@components/Layout/components/Container';

import { sxStyles, StyledAreaCardsWrap } from './AreasOfStudySection.styles';

export const AreasOfStudySection = () => {
  const isMobileScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
  const { data: studyAreas = [] } = useStudyAreas();

  const classificationsList = isMobileScreen ? classifications.slice(0, 5) : classifications.slice(0, 15);

  return (
    <Container>
      <CoreBox sx={sxStyles.headSection}>
        <CoreTypography variant="h2">Explore an area of study</CoreTypography>
        <Link to={ROUTES.SCHOOLS}>
          <ActionButton variant="outlined">Explore more</ActionButton>
        </Link>
      </CoreBox>

      <StyledAreaCardsWrap>
        {classificationsList.map((area) => (
          <AreaOfStudyCard
            key={area.cipCode}
            cipTitle={area.cipTitle}
            majors={studyAreas}
            currentCipCode={area.cipCode}
          />
        ))}
      </StyledAreaCardsWrap>
    </Container>
  );
};
